import { Iterable, IAddable, ObjUtils } from "./ObjUtils";
import { Dictionary } from "./Dictionary";
import { List } from "./List";

export class HashSet<T> implements Iterable<T>, IAddable<T> {
	private _map: Dictionary<T, T>;

	constructor(other?: Iterable<T>) {
		this._map = new Dictionary<T, T>();
		if(other)
			this.UnionWith(other);
	}

	public get Count(): number {
		return this._map.Count;
	}

	public ToList(): List<T> {
		return this._map.Keys();
	}

	public Contains(val: T): boolean {
		return this._map.ContainsKey(val);
	}

	public First(): T {
		var first = this._map.First();
		return first ? first.Key : null;
	}

    public Add(val: T): boolean {
		return this._map.Add(val, val);
	}

	public Remove(val: T): boolean {
		return this._map.Remove(val);
	}

	public Clear() {
		this._map.Clear();
	}

	public UnionWith(other: Iterable<T>) {
		other.ForEach((val) => {
			this.Add(val);
		});
	}

	public Intersect(other: Iterable<T>):HashSet<T> {
		var result = new HashSet<T>();
		other.ForEach((val) => {
			if (this.Contains(val))
				result.Add(val);
		});
		return result;
	}

	public ForEach(callbackfn: (value: T, index: number, array: T[]) => void, thisArg?: any): void {
		this._map.Values().ForEach(callbackfn, thisArg);
	}

	public Some(callbackfn: (value: T, index: number, array: T[]) => boolean, thisArg?: any): boolean {
		return this._map.Values().Some(callbackfn, thisArg);
	}

	public Every(callbackfn: (value: T, index: number, array: T[]) => boolean, thisArg?: any): boolean {
		return this._map.Values().Every(callbackfn, thisArg);
	}

	public Equals(obj: any): boolean {

		let other = (obj as HashSet<T>);
		if (!other) {
			return false;
		}

		if (this.Count != other.Count) {
			return false;
		}

		return !this.Some((value: T) => {
			return !other.Contains(value);
		});
	}

}
